export default __webpack_public_path__ + "static/media/hcp-hero.0fba307a.webp";